<template>
  <div>
    <div v-if="currentContent === 'listSizes'">
      <!-- <base-card>
        <base-question
          :text="
            targetItem.type === 'category'
              ? 'Esta categoria possui tamanhos?'
              : 'Este produto possui tamanhos?'
          "
          class="mb_20"
        />
        <base-radio
          label="Não"
          family="sizes"
          class="mb_15"
          :value="hasSizes"
          :option="false"
          @click="hasSizes = false"
        />
        <base-radio
          label="Sim"
          family="sizes"
          :value="hasSizes"
          :option="true"
          @click="hasSizes = true"
        />
      </base-card> -->
      <base-card>
        <base-question
          :text="
            targetItem.type === 'category'
              ? 'Configure os tamanhos desta categoria'
              : 'Configure os tamanhos deste produto'
          "
          class="mb_20"
        />
        <div v-if="targetItem.sizes.length > 0">
          <div v-for="sizeItem in targetItem.sizes" :key="sizeItem._id">
            <div v-if="!sizeItem.delete" class="sizes-container">
              <base-box sortBox class="size-box">
                <p>{{ sizeItem.name || 'Novo tamanho' }}</p>
              </base-box>
              <base-button
                design="four"
                @click.prevent="editSize(sizeItem._id)"
                class="size-button mr_15"
              >
                <i class="fal fa-pen"></i>
              </base-button>
              <base-button
                design="four"
                @click.prevent="deleteSize(sizeItem._id, false)"
                class="size-button"
              >
                <i class="fal fa-times"></i>
              </base-button>
            </div>
          </div>
        </div>

        <div class="d-flex justify-end w-100 mt_25">
          <base-button
            text="Adicionar tamanho"
            design="two"
            @click.prevent="openAddSizeContent()"
            class="w-100 mr_5"
          />
        </div>
      </base-card>
    </div>
    <div v-else class="add-size-content">
      <base-card>
        <base-question text="Qual é o tamanho?" class="mb_20" />

        <div class="size-row">
          <base-select
            class="size-item"
            :class="!hasPromo ? 'mr_15' : ''"
            title="Tipo da embalagem"
            placeholder="Tipo da embalagem"
            v-model="size.package"
            v-on:change="applyValue(size._id, 'package', size.package)"
            :valid="isValidField(size._id, 'package')"
          >
            <option
              v-for="(packageType, i) in availablePackages"
              :key="`package-${i}`"
              :value="packageType"
              :selected="size.package == packageType"
            >
              {{ PackageNames[packageType] }}
            </option>
          </base-select>
          <base-input
            v-if="!hasPromo"
            :label="StringLanguage.value"
            v-model="size.price"
            :money-mask="StringLanguage.currencyConfigs"
            class="size-item"
          />
        </div>
        <div class="size-row">
          <base-input
            class="size-item mr_15"
            label="Volume"
            :type="'number'"
            v-model="size.amount"
            v-on:change="applyValue(size._id, 'amount', size.amount)"
            :valid="isValidField(size._id, 'amount')"
            :activeMask="false"
          />
          <base-select
            title="Medida"
            class="size-item"
            v-model="size.unit"
            v-on:change="applyValue(size._id, 'unit', size.unit)"
            :valid="isValidField(size._id, 'unit')"
          >
            <option
              v-for="(unit, i) in availableUnits"
              :key="`unit-${i}`"
              :value="unit"
              :selected="size.unit == unit"
            >
              {{ unit }}
            </option>
          </base-select>
        </div>
        <div v-if="hasPromo" class="size-row">
          <base-input
            :label="StringLanguage.value"
            v-model="size.price"
            v-on:change="applyValue(size._id, 'price', size.price)"
            :money-mask="StringLanguage.currencyConfigs"
            class="size-item"
          />
          <base-input
            :label="StringLanguage.promo"
            v-model="size.originalPrice"
            v-on:change="
              applyValue(size._id, 'originalPrice', size.originalPrice)
            "
            :money-mask="StringLanguage.currencyConfigs"
            class="size-item ml_15"
          />
        </div>
        <base-checkbox v-model="hasPromo" :checked="hasPromo">
          <p class="checkbox-area">
            Esta bebida está em promoção neste tamanho
          </p>
        </base-checkbox>
      </base-card>
      <div v-if="!externalEditMode" class="footer">
        <div class="footer-container">
          <base-button
            design="four"
            class="mr_10 big footer-button"
            @click="cancel()"
          >
            <span>Cancelar</span>
          </base-button>

          <base-button class="ml_5 big footer-button" @click="saveSize()">
            <span v-if="editMode">Salvar tamanho</span>
            <span v-else>Criar tamanho</span>
          </base-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// components
import BaseCard from '@/components/Card';
import BaseQuestion from '@/components/Question';
import BaseInput from '@/components/Input';
import BaseButton from '@/components/Button';
import BaseRadio from '@/components/Radio';
import BaseSelect from '@/components/Select';
import BaseCheckbox from '@/components/Checkbox';
import BaseBox from '@/components/Box';
// libs
import Vue from 'vue';
import {
  PackageType,
  PackageNames,
} from 'easyjs/lib/Schema/Components/PackageType';
import { VolumeUnit } from 'easyjs/lib/Schema/Components/Unit';
// libs
import Builder from 'easyjs/lib/Schema/Components/Builder';

export default {
  components: {
    BaseCard,
    BaseQuestion,
    BaseInput,
    BaseButton,
    BaseSelect,
    BaseRadio,
    BaseCheckbox,
    BaseBox,
  },
  data() {
    return {
      errors: {
        main: [],
      },
      hasSizes: this.targetItem.sizes.length > 0,
      currentContent: 'listSizes',
      size: null,
      hasPromo: false,
      PackageNames,
      availablePackages: [
        PackageType.COPO,
        PackageType.GALAO,
        PackageType.GARRAFA,
        PackageType.JARRA,
        PackageType.LATA,
        PackageType.LONGNECK,
        PackageType.OTHER,
      ],
      availableUnits: [VolumeUnit.mL, VolumeUnit.L],
      editMode: false,
    };
  },
  props: {
    targetItem: { default: {} },
    changeFooter: { type: Function },
    externalEditMode: { default: false },
  },
  methods: {
    openAddSizeContent() {
      this.initSize();
      this.targetItem.sizeInProduct = true;
      this.currentContent = 'addSize';
      this.$emit('changeFooter', true);
    },
    saveSize() {
      const validSize =
        !!this.size.unit && !!this.size.amount && !!this.size.package;
      if (!validSize) {
        this.highlightErrorAddFields();
        alert(`O volume, medida e embalagem dos tamanhos são obrigatórios`);
        return;
      }

      if (this.editMode) {
        this.targetItem.sizes.forEach(size => {
          if (this.size && this.size._id === size._id) {
            size.package = this.size.package;
            size.price = this.size.price;
            size.unit = this.size.unit;
            size.amount = this.size.amount;
            size.originalPrice = this.size.originalPrice;
            size.name = this.size.name;
          }
        });
      } else {
        const sizeArray = [...this.targetItem.sizes];

        this.size.group = this.targetItem.group;
        sizeArray.push(this.size);
        Vue.set(this.targetItem, 'sizes', sizeArray);
      }

      this.currentContent = 'listSizes';
      this.$emit('changeFooter', false);
      this.size = null;
    },
    initSize() {
      if (!this.targetItem) {
        return;
      }

      this.size = Builder.factory('Size');
      this.size.new = true;
      this.size._id = Builder.generateRandomId('_');
      this.size.parent = this.targetItem._id;
    },
    deleteSize(id = null, showConfirm = true) {
      if (id) {
        const deleteFn = () => {
          this.targetItem
            .getItemsByParam('_id', id)
            .forEach(i => Vue.set(i, 'delete', true));
          //Remove todos os tamanhos que foram excluídos
          let catalog = Builder.factory('Catalog');
          catalog.addItems(this.targetItem);
          Builder.executeOnSchema(catalog, item => {
            if (item.sizes.length > 0) {
              Vue.set(
                item,
                'sizes',
                item.sizes.filter(s => !s.delete)
              );
            }
          });
        };

        if (showConfirm) {
          confirm(StringLanguage.confirmDelete, res => res && deleteFn());
        } else {
          deleteFn();
        }
      } else {
        this.targetItem.delete = true;
        this.$emit('saveItem', this.targetItem);
      }
    },
    editSize(sizeId) {
      const sizeFound = this.targetItem.sizes.find(size => size._id === sizeId);

      if (sizeFound) {
        this.size = Builder.mountSchema(JSON.parse(JSON.stringify(sizeFound)));
        this.editMode = true;
        this.currentContent = 'addSize';
        this.$emit('changeFooter', true);
      }
    },
    cancel() {
      this.size = null;
      this.currentContent = 'listSizes';
      this.$emit('changeFooter', false);
    },
    applyValue(_id, key, value) {
      this.size.getItemsByParam('_id', _id).forEach(i => {
        if (i.type == 'size') {
          Vue.set(
            i,
            'name',
            `${PackageNames[i.package]} (${i.amount} ${i.unit})`
          );
        }
        Vue.set(i, key, value);
      });
    },
    isValidField(_id, field) {
      return !this.errors[_id] || this.errors[_id].indexOf(field) == -1;
    },
    highlightErrorAddFields() {
      this.errors = { main: [] };

      if (this.size) {
        this.errors[this.size._id] = [
          !this.size.unit && 'unit',
          !this.size.package && 'package',
          !this.size.amount && 'amount',
        ].filter(s => !!s);
      }
    },
  },
  watch: {
    currentContent(newValue) {
      if (newValue === 'addSize') {
        this.errors = { main: [] };
        this.hasPromo = false;
      } else {
        this.editMode = false;
      }
    },
    hasSizes(newValue) {
      if (newValue === false) {
        this.size = null;
        this.targetItem.sizes = [];
      }
    },
  },
};
</script>

<style scoped>
.sizes-container {
  display: flex;
  align-items: flex-start;
  margin-bottom: 5px;
}
.size-box {
  flex: 1;
  display: flex;
  align-items: center;
  max-height: 45px;
  margin-right: 15px;
}
.size-box p {
  color: #aaaaaacc;
  font-size: 1.2em;
}
.size-button {
  height: 45px;
  border-color: #99999980;
}
.size-button i {
  font-size: 12px;
}
.size-row {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.size-item {
  flex: 1;
  margin-bottom: 0;
}
.add-size-content {
  /* position: relative;
  height: calc(100vh - 111px); */
  min-height: calc(100vh - 111px);
  padding-bottom: 111px;
}
.footer {
  /* ver aqui */
  background: var(--box);
  width: calc(100% + 30px);
  box-shadow: 0px 0px 6px #00000029;
  padding: 20px 15px;
  z-index: 1;
  position: absolute;
  bottom: 0;
  left: -15px;
}
.footer-container {
  display: flex;
  align-items: center;
  padding: 0 15px;
}
.footer-button {
  flex: 1;
}
.checkbox-area {
  color: #999999;
  font-size: 12px;
}
</style>
